import { createApp } from 'vue'
import router from '@/router'
import store from '@/store'
import WOW from 'wow.js'
import directive from '@/utils/directive'
import App from './App.vue'
import 'amfe-flexible'

//设备拦截
import '@/utils/deviceInterception'
new WOW({}).init()
const app = createApp(App)
app.use(router)
directive(app) //注册指令
app.use(store) // 挂载pinia
app.mount('#app')
